import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import AuthLoader from 'app/AuthLoader';
import { ErrorPage } from 'shared';
import local from 'services/localization/local';
import { loadSelfIdentity, loadABTestingSegment } from './action-creators';
import { getIdentityId } from './selectors';
import { profilesApiRoot as apiRoot, authClientId } from 'app/config';
import { signOut } from 'services/auth0-service';
const env = window.env || {};


export default function IdentityWrapper({ children }) {
  const dispatch = useDispatch();
  const identityId = useSelector(getIdentityId, shallowEqual);
  const loadError = useSelector(state => state.identity.loadError, shallowEqual);
  const loadErrorMessage = useSelector(state => state.identity.loginErrorMessage, shallowEqual);
  const [isIAL2Verification, setIsIAL2Verification] = useState(localStorage.getItem('IAL2Verification'));
  const isIdMeLogin = localStorage.getItem('isIdMeAuth');
  const errorMessage = `There is already an account associated with your email address in ${isIdMeLogin ? 'Calcium' : 'Id.me'}. Please login with your email and password that linked to ${isIdMeLogin ? 'Calcium' : 'Id.me'} account. Click here to login`;

  function logout() {
    if (isIdMeLogin) {
      localStorage.removeItem('id_token_expiry');
      localStorage.removeItem('id_token');
      localStorage.removeItem('isIdMeAuth');
      window.location.href = env.Idme_logouturl;
    } else {
      signOut();
    }
  }

  useEffect(() => {
    if (!identityId) {
      dispatch(loadSelfIdentity());
      dispatch(loadABTestingSegment());
    }
  }, [identityId]);

  // useEffect(async () => {
  //   if (isIAL2Verification) {
  //     const urlParams = new URLSearchParams(window.location.search);
  //     var code = urlParams.get('code');
  //     const error = urlParams.get('error');
  //     if (code) {
  //       let ehrPage = localStorage.getItem('IAL2VerificationRedirect');
  //       try{
  //         if(code.includes('Optional')){
  //           let resultdata = code.replace(/Optional\("(.+)"\)/, '$1');
  //           code = resultdata;
  //         }
  //       }
  //       catch{}
  //       await AuthorizeIdMeSignin(code, dispatch, false);
  //       localStorage.removeItem('IAL2Verification');
  //       localStorage.removeItem('IAL2VerificationRedirect');
  //       setIsIAL2Verification('');
  //       if(ehrPage){
  //         window.location.href = ehrPage;
  //       }
  //     }
  //     else if(error && error.includes('access_denied')){
  //       let redirectUri =`${localStorage.getItem('IAL2VerificationRedirect')}?error=access_denied`;
  //       localStorage.removeItem('IAL2Verification');
  //       localStorage.removeItem('IAL2VerificationRedirect');
  //       setIsIAL2Verification('');
  //       window.location.href = redirectUri;
  //     }
  //     else{
  //        setIsIAL2Verification('');
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (!isIAL2Verification) {
      return;
    }

    let mounted = true;

    const runAsync = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      let code = urlParams.get('code');
      const error = urlParams.get('error');

      if (code) {
        let ehrPage = localStorage.getItem('IAL2VerificationRedirect');

        try {
          if (code.includes('Optional')) {
            let resultdata = code.replace(/Optional\("(.+)"\)/, '$1');
            code = resultdata;
          }
        } catch (e) {
          // swallow parsing errors — keep behavior consistent with original
        }

        try {
          // call AuthorizeIdMeSignin and await result
          await AuthorizeIdMeSignin(code, dispatch, false);

          // only update localStorage / state if still mounted
          if (!mounted) return;

          localStorage.removeItem('IAL2Verification');
          localStorage.removeItem('IAL2VerificationRedirect');
          setIsIAL2Verification('');

          if (ehrPage) {
            window.location.href = ehrPage;
          }
        } catch (err) {
          // If AuthorizeIdMeSignin throws (it currently doesn't), handle here
          console.error('AuthorizeIdMeSignin error', err);
        }
      } else if (error && error.includes('access_denied')) {
        let redirectUri = `${localStorage.getItem('IAL2VerificationRedirect')}?error=access_denied`;
        localStorage.removeItem('IAL2Verification');
        localStorage.removeItem('IAL2VerificationRedirect');
        setIsIAL2Verification('');
        window.location.href = redirectUri;
      } else {
        // no code, no access_denied — just clear flag
        setIsIAL2Verification('');
      }
    };

    runAsync();

    // cleanup flag if component unmounts while async work is in-flight
    return () => {
      mounted = false;
    };
  }, [isIAL2Verification, dispatch]);


  if (loadError && !loadErrorMessage?.includes('Login failed')) {
    return <ErrorPage>{local.errorLoadProfile}</ErrorPage>;
  }

  if (loadError && loadErrorMessage?.includes('Login failed')) {
    return (
      <ErrorPage hideReload={true}><div style={{ cursor: 'pointer' }} onClick={logout}>{errorMessage}</div></ErrorPage>
    );
  }

  if (!identityId || isIAL2Verification) {
    return <AuthLoader />;
  }

  return children;
}

function AuthorizeIdMeSignin(code, dispatch, dispatchToken = true) {
  // let url = `https://profiles-api-dev-owen.myhc.app/idme-token?code=${code}&redirectUrl=https://dev-owen.myhc.app/`;
  let url = `${env.API_ROOT_PROFILES}/idme-token?code=${code}&redirectUrl=${env.Idme_redirectionurl}&isIAL2Verification=${true}`;
  let header = {
    'Content-Type': 'application/json'
  };
  return fetch(url, {
    method: 'Get',
    headers: header
  }).then(response => {
    return response.json();
  })
    .then(data => {
      return data;
    })
    .catch(error => {
      console.log(error);
      var errorDetails = JSON.stringify(error);
      alert('IAL2Verification - Error occured while connecting to id.me :' + url + ' ' + errorDetails);
      return null;
    });
}
